const US = {
    moduleTitle: 'Frequently Asked Questions',
};
export const D_DATA: {
    [key: string]: {
        moduleTitle: string;
    };
} = {
    us: {
        ...US,
    },
    eu: {
        ...US,
    },
    uk: {
        ...US,
    },
    ca: {
        ...US,
    },
    au: {
        ...US,
    },
    za: {
        ...US,
    },
    cn: {
        moduleTitle: '常见问题',
    },
    de: {
        moduleTitle: 'Häufig gestellte Fragen',
    },
    fr: {
        moduleTitle: 'Questions et réponses',
    },
    it: {
        moduleTitle: 'Domande frequenti',
    },
    es: {
        moduleTitle: 'Preguntas frecuentes',
    },
    jp: {
        moduleTitle: 'よくあるご質問',
    },
    kr: {
        moduleTitle: '자주 묻는 질문',
    },
    sa: {
        moduleTitle: 'الأسئلة الشائعة',
    },
    tw: {
        moduleTitle: '常見問題 (FAQ)',
    },
    br: {
        moduleTitle: 'Perguntas frequentes',
    },
    mx: {
        moduleTitle: 'Preguntas frecuentes',
    },
    ph: {
        ...US,
    },
    nl: {
        moduleTitle: 'Veelgestelde vragen',
    },
};
